<form (ngSubmit)="submitDependent()" *ngIf="dependent" #memberForm="ngForm" fxLayout="column" fxLayoutAlign="start start" fxFlexFill>
  <div fxFlexFill class="fxGap-large" fxLayout="column">
    <h2 style="text-align: center">Tobacco use premium surcharge attestation</h2>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div class="h4">
        <span *ngIf="!isSebb">
          Attest to whether the surcharge below applies to this dependent by checking the appropriate box. Then, select the button below to continue.
          <br />
          <br />
          <br />
          <a href="https://www.hca.wa.gov/employee-retiree-benefits/public-employees/surcharges" target="_blank">Learn about this surcharge</a> before you make your attestation.
          <br />
          <br />
          The PEBB Program requires a $25-per-account premium surcharge in addition to your monthly medical premium if you or an enrolled dependent (age 13 or older) uses a tobacco product. Tobacco use is defined as any use of tobacco products within the past two months except for religious or ceremonial use.
          <br><br/>
          If you check Yes in this section, you will be charged the $25 premium surcharge. 
          <br />
        </span>
        <span *ngIf="isSebb">
          Attest to whether the surcharge below applies to this dependent by checking the appropriate box.  Then select the button below to continue.
          <br />
          <br />          
          <a href="https://www.hca.wa.gov/employee-retiree-benefits/school-employees/surcharges" target="_basic">Learn about this surcharge before you make your attestation</a>. 
          The SEBB Program requires a $25-per-account premium surcharge in addition to your monthly medical premium if you or an enrolled dependent (age 13 or older) uses a 
          tobacco product. Tobacco use is defined as any use of tobacco products within the past two months except for religious or ceremonial use.
          <br/>
          If you check Yes in this section, you will be charged the $25 premium surcharge.
        </span>
      </div>
    </div>
    <div  fxLayoutAlign="space-around" fxLayout="row">
      <div fxLayout="row" style="width: 400px">
        <div class="h4 no-mg">
          Does the tobacco use premium surcharge apply to this dependent? <span *ngIf="isSebb">Select Yes or No</span>
        </div>
      </div>
      <yes-no
        name="hasTobacco"
        [isTobaccoAttestation]="true"
        [isTobaccoAttestationSubscriber]="false"
        [isSebb] = "isSebb"
        [orientation]="'vertical-list'"
        yesLabel="Yes, I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past two months."
        noLabel="No, I am not subject to the $25 premium surcharge. This dependent has not used tobacco in the past two months or has enrolled in or accessed tobacco cessation resources."
        style="padding-left: 75px; padding-right: 75px; margin-bottom: 30px;"
        [(ngModel)]="yesTobacco"
        [required]="true"
        (change)="updateTobacco()"
        ></yes-no>
    </div>
    <div fxFlexFill fxLayout="row" fxLayoutAlign="end end">
      <button [disabled]="this.yesTobacco === undefined || this.yesTobacco === null" fxFlex="30" id="sub-add-submit-btn" type="submit" class="btn btn-primary" *ngIf="dependent.partnershipStartDate">Continue to the  Spouse or state-registered domestic partner coverage surcharge attestation</button>
      <button [disabled]="this.yesTobacco === undefined || this.yesTobacco === null" fxFlex="30" id="sub-add-submit-btn" type="submit" class="btn btn-primary" *ngIf="!dependent.partnershipStartDate" >Proceed to dependent review</button>
      <!-- <button fxFlex="30" id="sub-add-cancel-btn" (click)="cancelAdd.emit()" class="btn btn-light">Cancel</button> -->
    </div>
  </div>
</form>
